import { createSvgIcon } from '@mui/material/utils';

export const ShareIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none">
    <path
      d="M13.2649 24.3076L17.4771 28.5005C17.7355 28.7653 18.0587 28.9581 18.4145 29.0598C18.7703 29.1615 19.1465 29.1685 19.5059 29.0801C19.8675 28.996 20.2014 28.8204 20.4755 28.57C20.7496 28.3196 20.9547 28.0028 21.071 27.6503L27.9882 6.9179C28.1326 6.52944 28.1624 6.10769 28.074 5.70279C27.9857 5.2979 27.783 4.92688 27.4899 4.63384C27.1969 4.3408 26.8259 4.13806 26.421 4.04973C26.0161 3.9614 25.5943 3.99118 25.2059 4.13555L4.47347 11.0528C4.10877 11.1774 3.78395 11.3971 3.53258 11.6892C3.28122 11.9813 3.11242 12.3353 3.04365 12.7145C2.97266 13.0593 2.98846 13.4165 3.08964 13.7537C3.19081 14.091 3.37419 14.3978 3.6233 14.6467L8.9175 19.9409L8.7436 26.6455L13.2649 24.3076Z"
      stroke="currentColor"
      strokeWidth="3.15"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.3697 4.56058L8.91733 19.9408"
      stroke="currentColor"
      strokeWidth="3.15"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'Share',
);
